// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__O5syF","footer":"ModalUpdate_footer__3M8k4"};